<template>
  <div class="imgStyle">
    <!-- <div v-for="(items, indexs) in imgList" :key="indexs" class="imgListItems">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="item !== '' ? 'imgListItem' : 'imgListItemNull'"
      >
        <img
          v-if="item !== ''"
          :src="getImgUrl(item)"
          class="imgListItemStyle"
        />
      </div>
    </div> -->
    <row>
      <i-col
        :lg="4"
        :md="6"
        :sm="6"
        :xs="6"
        v-for="(items, indexs) in imgList"
        :key="indexs"
        class="colStyle"
      >
        <img
          v-if="items !== ''"
          :src="getImgUrl(items)"
          class="imgListItemStyle"
        />
      </i-col>
    </row>
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    getImgUrl(icon) {
      return require("../../../../public/static/image" + icon);
    }
  }
};
</script>

<style scoped>
.colStyle {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin: 15px 0;
  border: 1px solid #0000;
}
.imgStyle {
}
@media screen and (min-width: 1400px) {
  .imgStyle {
    padding: 20px 0;
    padding-left: 15vw;
    padding-right: 15vw;
    text-align: center;
  }
}
@media screen and (max-width: 1400px) {
  .imgStyle {
    padding: 20px 0;
    padding-left: 15vw;
    padding-right: 15vw;
    text-align: center;
  }
}
@media screen and (max-width: 1000px) {
  .imgStyle {
    padding: 5px 0;
    padding-left: 3vw;
    padding-right: 3vw;
  }
}
@media screen and (max-width: 960px) {
  .imgStyle {
    padding: 20px 0;
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
  }
}
.imgListItem {
  border: 1px solid #313131;
  margin: 15px 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7vw;
  min-width: 100px;
}
.imgListItemNull {
  margin: 15px 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7vw;
  min-width: 100px;
}
.imgListItems {
  display: flex;
  justify-content: center;
}
.imgListItemStyle {
  width: 65%;
  padding: 5px 5%;
  margin: 5px 30%;
  border: 1px solid #313131;
}
</style>
